export const CategoryPages = 'Category Pages';
